<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flow: [
            {
              name: '第三方优惠券接入流程',
              desc: [
                '1、发放优惠券',
                {
                  preData: "第三方系统通过调起接口  ",
                  link:  " 开放平台提供-发放优惠券",
                  url: "thirdCouponSend",
                  endData: " 向我方平台发送优惠券信息，我方平台将该券信息保存；"
                },
                '2、优惠券使用',
                {
                  preData: "A）嵌入我方微信支付H5页面，第三方系统通过调起我方接口 ",
                  link:  " 第三方会员无缝嵌入智慧停车微信",
                  url: "thirdMemberLogin",
                  endData: " 嵌入支付界面；车主选定相应车牌查费，"
                },
                [
                  {
                    preData: "B）获取券信息，开放平台会对该车是否有第三方优惠券进行判断，若该优惠券保存在第三方系统，则开放平台会通过接口 ",
                    link:  " 第三方接提供-获取车牌可用优惠券列表",
                    url: "thirdCouponGetByCarCode",
                    endData: " 向第三方系统发起查询优惠券列表请求，取得优惠券列表；若该券保存在开放平台，则省略这一步；"
                  },
                  {
                    preData: "若取得的券需要校验，则我方开放平台会通过接口 ",
                    link:  " 第三方接入提供-获取优惠券详情",
                    url: "thirdCouponGetByCouponCode",
                    endData: " 主动向第三方系统获取该券详情；"
                  },
                ],
                {
                  preData: "C）使用券，车主选券缴费，则开放平台会通过接口 ",
                  link:  " 第三方接入提供-核销/使用优惠券",
                  url: "thirdCouponUse",
                  endData: " 通知第三方系统该券已使用，供第三方核销该券"
                },

              ],
              url: '/static/img/thirdPartyCoupons.svg'
            },
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/thirdCoupon/thirdCouponFlow.vue